'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _measurementsConnect = require('../measurementsConnect');

var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);

var _propsComparisons = require('../../../utils/react/propsComparisons');

var _measurementsRegistry = require('../measurementsRegistry');

var _measurementsRegistry2 = _interopRequireDefault(_measurementsRegistry);

var _measurementsSelector = require('../measurementsSelector');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Utils


// Measurements


// Prop comparisons
var nowHasAllMeasurements = (0, _propsComparisons.now)('hasAllMeasurements');

var mapMeasurementsStateToProps = function mapMeasurementsStateToProps(state, ownProps) {
    var canvasElementIds = ownProps.canvasElementIds;

    var measurementsMap = (0, _measurementsSelector.getMeasurementsMap)(state);
    var hasAllMeasurements = canvasElementIds.every(function (elId) {
        return !!measurementsMap.get(elId);
    });
    return { hasAllMeasurements: hasAllMeasurements };
};

var CANVAS_LOADING_CLASS = 'canvas-loading';

exports.default = function (DecoratedComponent) {
    var _dec, _class;

    var MeasureCanvasDecorator = (_dec = (0, _measurementsConnect2.default)(mapMeasurementsStateToProps), _dec(_class = function (_React$Component) {
        _inherits(MeasureCanvasDecorator, _React$Component);

        function MeasureCanvasDecorator(props) {
            _classCallCheck(this, MeasureCanvasDecorator);

            var _this = _possibleConstructorReturn(this, (MeasureCanvasDecorator.__proto__ || Object.getPrototypeOf(MeasureCanvasDecorator)).call(this, props));

            _this.state = { readyToMeasure: false };
            return _this;
        }

        _createClass(MeasureCanvasDecorator, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var canvasNode = _reactDom2.default.findDOMNode(this);
                _measurementsRegistry2.default.registerCanvas(canvasNode);
                canvasNode.classList.add(CANVAS_LOADING_CLASS);
                this.setState({ readyToMeasure: true }); // eslint-disable-line react/no-did-mount-set-state
            }
        }, {
            key: 'componentWillUpdate',
            value: function componentWillUpdate(nextProps, nextState) {
                if (!nextState.readyToMeasure) return;

                if (nextProps.currentBoardId !== this.props.currentBoardId) {
                    var canvasNode = _reactDom2.default.findDOMNode(this);
                    canvasNode.classList.add(CANVAS_LOADING_CLASS);
                }

                if (nowHasAllMeasurements(this.props, nextProps)) {
                    var _canvasNode = _reactDom2.default.findDOMNode(this);
                    _canvasNode.classList.remove(CANVAS_LOADING_CLASS);
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                _measurementsRegistry2.default.removeCanvas();
            }
        }, {
            key: 'render',
            value: function render() {
                var readyToMeasure = this.state.readyToMeasure;

                var _props = this.props,
                    hasAllMeasurements = _props.hasAllMeasurements,
                    rest = _objectWithoutProperties(_props, ['hasAllMeasurements']); // eslint-disable-line no-unused-vars

                return _react2.default.createElement(DecoratedComponent, _extends({ readyToMeasure: readyToMeasure }, rest));
            }
        }]);

        return MeasureCanvasDecorator;
    }(_react2.default.Component)) || _class);


    MeasureCanvasDecorator.propTypes = {
        hasAllMeasurements: _propTypes2.default.bool,
        currentBoardId: _propTypes2.default.string
    };

    return MeasureCanvasDecorator;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/measurements/store/measureCanvasDecorator.js
// module id = 1911
// module chunks = 0